var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "svg-icon" }, [
    _c(
      "svg",
      {
        staticClass: "svg-inline--fa fa-lock-alt fa-w-15 fill-current",
        class: ["fa-" + _vm.size, _vm.classNames],
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: _vm.viewBox,
          alt: _vm.name + " icon",
          role: "presentation"
        }
      },
      [
        _c("title", { attrs: { lang: "en" } }, [_vm._v(" icon")]),
        _vm._v(" "),
        _c(
          "g",
          { staticClass: "fill-current" },
          [_c(_vm.Icon, { ref: "svg-icon", tag: "component" })],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c("p", [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d4f4e49", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d4f4e49","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/SvgIcon.vue
// module id = null
// module chunks = 